import {OrganisationId} from '@/models/enums/OrganisationId';
import {ProductType} from '@/commons/enums/ProductType';
import { cloneDeep } from 'lodash-es';

export type UpdateClientAgreements = {
  clientId: number;
  agreements: Agreement[];
  smsCode: string;
}

export class ClientAgreements {
  acceptsProcessing: boolean = false;
  acceptsReceivingInfo: boolean = false;
  acceptsReceivingOffers: boolean = false;
  acceptsBigInquiry: boolean = false;
  acceptsReceivingOffersPartner: boolean = false;
  acceptsProcessingPartner: boolean = false;
  acceptsReceivingInfoPartner: boolean = false;
  acceptsProcessingLead: boolean = false;
  acceptsRealEstate: boolean = false;
  acceptsBankSecrecy: boolean = false;
}

export enum AgreementMethod {
  SMS = 'Sms',
  SCAN = 'Scan',
  PHONE = 'Phone',
  WEB = 'Web',
  UNKNOWN = 'Unknown',
}

type AgreementKind = 'PersonalDataProcessing' | 'CommercialInformation' | 'Marketing';

export type LendiCareAgreements = `AcceptsLendiCare${AgreementKind}`
export type AgreementOrganisation = 'Lendi' | 'Finamax' | 'Imobiliare' | 'Big' | 'HomeEstate';

export type AgreementType = LendiCareAgreements | Exclude<`Accepts${AgreementOrganisation}${AgreementKind}`, 'AcceptsBigCommercialInformation' | 'AcceptsBigMarketing'>;

export class Agreement {
  method?: AgreementMethod;
  type?: AgreementType;
  at?: string;
  value?: boolean;

  constructor(type?: AgreementType) {
    this.type = type;
    this.value = false;
    this.method = AgreementMethod.SMS;
  }
}

export interface IAgreementItemLabel {
  title?: string;
  label: string;
}

export interface IAgreementItemWithUrl {
  title: string;
  url: string;
}

export interface IAgreementItemViewModel extends IAgreementItemLabel {
  key: AgreementType;
  required: (v?: Agreement[]) => boolean;
  organisationIds?: OrganisationId[];
  productTypes: Array<ProductType>;
  isEditable: boolean;
  isRealEstate?: boolean;
  isCompany?: boolean;
}

export const getAgreementByType = (agreements: Agreement[], type: AgreementType, defaultMethod: AgreementMethod = AgreementMethod.SMS, createIfNotFound: boolean = true) => {
  // TODO: usunąć to, tymczasowe zabezpieczenie
  if (!Array.isArray(agreements)) {
    agreements = [];
  }

  let agreement = agreements.find((agreement) => agreement.type === type);
  if (agreement) {
    return agreement;
  } else {
    agreement = new Agreement(type);
    agreement.method = defaultMethod;
    if (createIfNotFound) {
      agreements.push(agreement);
    }
    return agreement;
  }
}

export const isAgreementChecked = (agreements: Agreement[], type: AgreementType) => {
  return !!getAgreementByType(agreements, type, undefined, false)?.value;
}

export const getAgreementsRecord = <T extends AgreementType>(agreements: Agreement[], types: T[], defaultMethod: AgreementMethod = AgreementMethod.SMS, cloneAgreements: boolean = false): Record<T, Agreement> => {
  return types.reduce((acc, type) => {
    acc[type] = getAgreementByType(cloneAgreements ? cloneDeep(agreements) : agreements, type, defaultMethod);
    return acc;
  }, {} as Record<T, Agreement>);
}
export type agreement = Record<AgreementType, IAgreementItemLabel>;